import { useId } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { Checkbox } from '@motorway/mw-highway-code/alpha';

import { ServiceFeeAppliesNotice } from 'Components/transactionFees/ServiceFeeAppliesNotice/ServiceFeeAppliesNotice';

import { SellerConfirmationExperimentProps } from '../SellerConfirmationExperiment.types';

import texts from './AcceptAndConfirmSale.texts.json';
import { useAcceptAndConfirmSale } from './useAcceptAndConfirmSale';

import styles from './AcceptAndConfirm.scss';

const LocalT = new MDText(texts);

export const AcceptAndConfirmSale = ({
  className,
  isServiceFeeEnabled,
  offer,
  serviceFeeDetails,
  vehicleEnquiry,
}: SellerConfirmationExperimentProps & { className?: string }) => {
  const { loading, onSubmit } = useAcceptAndConfirmSale({
    errorProps: {
      content: <div>
        <p data-thc-style-override>{LocalT.translate('error.content')}</p>
        <Button label={LocalT.translate('error.cta')} onClick={() => globalThis.location.reload()} size="small" variant="secondary" />
      </div>,
      heading: LocalT.translate('error.heading'),
    },
    offer,
    vehicleEnquiry,
  });
  const { serviceFee, serviceFeeTiers } = serviceFeeDetails || {};
  const formattedPrice = `£${offer?.closingBid?.value?.toLocaleString() ?? ''}`;
  const checkboxId = useId();

  return <div className={cx(styles.wrapper, className)}>
    <div className={styles.offer}>
      <span className={styles.label}>Your highest offer</span>
      <strong className={styles.value}>{formattedPrice}</strong>
      {isServiceFeeEnabled && serviceFeeTiers && <ServiceFeeAppliesNotice
        feeAmountGBP={serviceFee?.feeAmountGBP}
        label={LocalT.translate('feeLabel') as string}
        serviceFeeTiers={serviceFeeTiers}
        variant="small"
      />}
    </div>
    <form className={styles.form} onSubmit={onSubmit}>
      <Checkbox
        data-thc-checkbox
        formProps={{
          input: {
            required: true,
          },
        }}
        id={checkboxId}
        label={LocalT.translate('checkbox', {
          dealer: offer.closingBid?.dealerContact?.dealer?.name ?? '',
          offer: formattedPrice,
        })}
      />
      <Button
        data-thc-button
        fullWidth
        disabled={loading}
        icon="arrow"
        label={LocalT.translate('cta')}
        loading={loading}
        type="submit"
      />
    </form>
  </div>;
};
